// types
import { IFolder } from './types'
// components
import { ChildrenView } from '../../components/ChildrenView'
import { isParameterApp } from '../../parameterApps';


export function OperatorPanel(props: IFolder) {

    return (
        <ChildrenView resourceGroupId={props.resourceGroupId} parentId={props.id} filter={(app) => !isParameterApp(app.schema)}/>
    );
}
